import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import EnhanceModelPanel from './Components/EnhanceModelPanel/EnhanceModelPanel'
import ViewerSidebarItem from './Components/ViewerSidebarItem/ViewerSidebarItem'
import useViewerSidebar from './useViewerSidebar'

function ViewerSidebar({ isModelOpened = false }) {
  const {
    isOpen,
    navigationItems,
  } = useViewerSidebar(isModelOpened)

  return (
    <div className="viewer-sidebar">
      <EnhanceModelPanel isOpen={isOpen} />
      <nav
        className={classnames(
          'viewer-sidebar__nav',
          isOpen && 'viewer-sidebar__nav--opened',
        )}
        aria-label="viewer-sidebar"
      >
        {navigationItems.map(({
          id,
          ...rest
        }) => (
          <ViewerSidebarItem
            key={id}
            id={id}
            {...rest}
          />
        ))}
      </nav>
    </div>
  )
}

ViewerSidebar.propTypes = {
  isModelOpened: bool,
}

export default memo(ViewerSidebar)
